const config = {
    'searchList': {
        'searchTxt': [
            {
                'name': '供应商编码',
                'value': 'supplierCode',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '供应商名称',
                'value': 'supplierName',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '司机手机号码',
                'value': 'phoneNo',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '司机名称',
                'value': 'driverName',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                "name": "申请结果",
                "value": "applyStatus",
                "type": "select",
                "unfold": true,
                "span": 3,
                "optionNum": "SRM_JOIN_APPLY_STATUS",
                "multiple": false
            },
            {
                "name": "供应商新增司机审批状态",
                "value": "approvalStatus",
                "type": "select",
                "unfold": true,
                "span": 3,
                "optionNum": "SRM_AUDIT_STATUS",
                "multiple": false
            },
            {
                'name': '申请时间',
                'value': 'timeRange',
                'type': 'time',
                // 'timeType': 'datetimerange',
                'startPlaceholder': '开始时间',
                'endPlaceholder': '结束时间',
                'unfold': true,
                'span': 6
            }
        ],
        'unfoldState': false,
        'advancedBtn': true,
        'resetBtn': true
    },
    'table': {
        'leftOperation': true,
        'leftWidth': 150,
        'selectBtn': true,
        'height': 'calc(100vh - 206px)',
        'columns': [
            {
                'label': '序号',
                'prop': 'id',
                'width': '100px'
            },
            {
                'label': '申请编码',
                'prop': 'applyCode',
                'width': '200px'
            },
            {
                'label': '供应商编码',
                'prop': 'supplierCode',
                'width': '200px'
            },
            {
                'label': '供应商名称',
                'prop': 'supplierName',
                'width': '200px'
            },
            {
                'label': '申请司机编码',
                'prop': 'driverCode',
                'width': '200px'
            },
            {
                'label': '申请司机名称',
                'prop': 'driverName',
                extraTags: [
                    { name: '已注销', color: '#f2f2f2' },
                ],
                'width': '110px'
            },
            {
                'label': '申请司机手机号码',
                'prop': '_phoneNo',
                extraTags: [
                    { name: '已注销', color: '#f2f2f2' },
                ],
                'width': '150px'
            },
            {
                'label': '驾驶证有效期',
                'prop': 'driveEndDate',
                'width': '200px'
            },
            {
                'label': '是否带车加入',
                'prop': 'isWithCar',
                'width': '200px',
                type: 'select',
                'options': [
                    {
                        label: '否',
                        value: '0'
                    },{
                        label: '是',
                        value: '1'
                    },
                ],
            },
            {
                'label': '申请时间',
                'prop': 'createTime',
                'width': '200px'
            },
            {
                'label': '申请状态',
                'prop': 'applyStatus',
                type: 'select',
                'width': '200px',
                "optionNum": "SRM_JOIN_APPLY_STATUS",
            },
            {
                'label': '供应商新增司机审批状态',
                'prop': 'approvalStatus',
                "type": "select",
                "optionNum": "SRM_AUDIT_STATUS",
                'width': '200px'
            },
            {
                'label': '驳回原因',
                'prop': 'reject',
                'type': 'button',
                'width': '200px',
            },
            {
                'label': '处理人',
                'prop': 'approvalUserName',
                'width': '200px'
            },
            {
                'label': '处理时间',
                'prop': 'approvalTime',
                'width': '200px'
            }
        ],
        'action': [
            {
                'type': 'text',
                'label': '司机信息',
                'size': 'small',
                'event': 'driver'
            },
            {
                'type': 'text',
                'label': '车辆',
                'size': 'small',
                'event': 'vehicle'
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100]
    }
};
export default config;